const BFRAME_SELECTOR = 'iframe[src*="recaptcha"][src*="bframe"]';

export function recaptchaChallengeWrapper() {
    const iframe = document.querySelector(BFRAME_SELECTOR);
    if (!iframe || !iframe.parentElement) {
        return null;
    }
    return iframe.parentElement.parentElement || iframe.parentElement;
}

export function isRecaptchaChallengeVisible() {
    const wrapper = recaptchaChallengeWrapper();
    if (!wrapper) {
        return false;
    }
    const style = window.getComputedStyle(wrapper);
    return style.visibility !== 'hidden'
        && style.display !== 'none'
        && style.opacity !== '0';
}

export function watchRecaptchaChallengeClosed(onClosed) {
    if (typeof onClosed !== 'function') {
        throw new Error('watchRecaptchaChallengeClosed: onClosed is required');
    }

    let seenOpen = false;
    let stopped = false;

    function tick() {
        if (stopped) {
            return;
        }
        if (isRecaptchaChallengeVisible()) {
            seenOpen = true;
            return;
        }
        if (!seenOpen) {
            return;
        }
        stop();
        onClosed();
    }

    const timer = window.setInterval(tick, 100);

    function stop() {
        if (stopped) {
            return;
        }
        stopped = true;
        window.clearInterval(timer);
    }

    tick();
    return stop;
}
